import {useAuthContext} from 'geestack-toolbox';
import {useHistory} from 'react-router-dom';
import useOpenApi from '../Http/useOpenApi';
import {useMount} from 'react-use';
import {useOpenApiFpRequest} from '../Http/useOpenApiRequest';
import useAuth from '../utils/AuthContext';
import {AuthorizeApi} from '../scaffold';
import CommonApiErrorHandler from '../utils/HttpInstance';

export default function useCheckAuth() {
  const auth = useAuth();
  const history = useHistory();
  const checkRequest = useOpenApiFpRequest(AuthorizeApi, AuthorizeApi.prototype.authorizeHeartbeatGet);

  return {
    isChecking: checkRequest.loading,
    check: async () => {
      const localToken = localStorage.getItem('Application-Token');
      if (localToken) {
        auth.setToken(localToken);
        checkRequest
          .request({body: localToken})
          .then(i => auth.setCurrentUser(i))
          .catch(CommonApiErrorHandler);
      }
    },
  };
}
